import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Encounter } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_ENCOUNTER_BY_ID_KEY = 'get-encounter-by-id';

export const useGetEncounterById = (id: number) => {
  return usePermittedQuery<Encounter>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/encounter/${id}`,
    {},
    [GET_ENCOUNTER_BY_ID_KEY],
    {
      enabled: typeof id === 'number' && id > 0,
      refetchOnWindowFocus: false,
    },
  );
};
